import { SettingsIcon } from "@xola/icons";
import { SecondaryButton } from "common";
import React, { useEffect, useState } from "react";
import { FilterItem } from "./ListFilter";
import { MultiSelectPopover } from "@/components/MultiSelectPopover";
import { useModal } from "@/hooks/useVisibility";
import { useDashboardFilterStore } from "@/stores/dashboardFilterStore";

export const DashboardDisplayOptions = () => {
    const popover = useModal();
    const displayOptions = useDashboardFilterStore((state) => state.displayOptions);
    const [expandAllRows, setExpandAllRows] = useState(displayOptions.expandAllRows);
    const [showSummaryRows, setShowSummaryRows] = useState(displayOptions.showSummaryRows);

    useEffect(() => {
        if (displayOptions) {
            setExpandAllRows(displayOptions?.expandAllRows);
            setShowSummaryRows(displayOptions?.showSummaryRows);
        }
    }, [displayOptions]);

    const handleApply = () => {
        useDashboardFilterStore.getState().setDisplayOptions({ expandAllRows, showSummaryRows });
        popover.toggle();
    };

    const handleClose = () => {
        setExpandAllRows(displayOptions?.expandAllRows);
        setShowSummaryRows(displayOptions?.showSummaryRows);

        popover.toggle();
    };
    return (
        <span className="ml-auto inline-flex align-top">
            <MultiSelectPopover
                title="Display Options"
                isVisible={popover.isVisible}
                zIndex={50}
                placement="auto"
                target={
                    <SecondaryButton
                        size="small"
                        className="items-center px-1.5 text-sm font-bold"
                        onClick={popover.toggle}
                    >
                        <SettingsIcon size="medium" />
                    </SecondaryButton>
                }
                showSearch={false}
                onApply={handleApply}
                onCancel={handleClose}
            >
                <MultiSelectPopover.Item key="allRows" className="border-b border-gray-light py-3">
                    <FilterItem
                        label="Expand all rows"
                        isChecked={expandAllRows}
                        onChange={() => setExpandAllRows(!expandAllRows)}
                    />
                </MultiSelectPopover.Item>
                <MultiSelectPopover.Item key="summaryRows" className="border-b border-gray-light last:border-b-0">
                    <FilterItem
                        label="Show summary rows"
                        isChecked={showSummaryRows}
                        onChange={() => setShowSummaryRows(!showSummaryRows)}
                    />
                </MultiSelectPopover.Item>
            </MultiSelectPopover>
        </span>
    );
};
